import SavedSeedPhrases from './SavedSeedPhrases'

export default SavedSeedPhrases
